import { ReactElement, ReactNode } from 'react'

import { cn } from '@/app/utils'
import { AppButton } from '@/components/shared/button'
import { AppModal } from '@/components/shared/modal'

import { AppModalProps } from './Modal'

type Props = {
  message: ReactNode
  closeButtonText: string
  submitButtonText: string
  submitButtonClassName?: string
  messageClassName?: string
  onSubmit: () => void
  noBackdrop?: boolean
  className?: string
  reverseButtons?: boolean
  image?: ReactElement
} & AppModalProps

const ConfirmSubmitModal = ({
  message,
  closeButtonText,
  submitButtonText,
  submitButtonClassName,
  messageClassName,
  onClose,
  onSubmit,
  reverseButtons = false,
  className,
  noBackdrop,
  image,
  ...props
}: Props) => (
  <AppModal
    {...props}
    overlayClassName={cn(!noBackdrop && 'backdrop-blur', '!bg-black/50')}
    className={cn('mx-16 !max-w-[518px] sm:!h-auto sm:!rounded-16', className)}
    onClose={onClose}
  >
    <div className="flex justify-center pb-20">{image}</div>
    <p className={cn('!text-grey-70 text-20 sm:text-18', messageClassName)}>
      {message}
    </p>

    <div
      className={cn(
        'mt-20 flex gap-16 sm:mt-32 sm:flex-col sm:gap-12',
        reverseButtons && 'flex-col-reverse gap-12'
      )}
    >
      <AppButton
        variant="backless"
        size="large"
        className="w-full sm:order-2 sm:!h-44"
        data-testid="confirm-submit-modal-close-button-id"
        onClick={onClose}
      >
        {closeButtonText}
      </AppButton>
      <AppButton
        variant="secondary"
        size="large"
        className={cn('w-full sm:!h-44', submitButtonClassName)}
        data-testid="confirm-submit-modal-submit-button-id"
        onClick={onSubmit}
      >
        {submitButtonText}
      </AppButton>
    </div>
  </AppModal>
)

export default ConfirmSubmitModal
